import { connect, MapDispatchToProps } from 'react-redux';
import { showReportModal as showReportModalAction } from '../../../../Moderation/redux/actions';
import { deleteDeviation as deleteDeviationAction } from '../../../../redux/deviations/actionCreators';
import { addNotification } from '../../../../Notifications/redux/actionCreators';
import { NotificationType } from '../../../../Notifications/redux/types';

import { Props } from './FeedCardLayout';

export type DispatchProps = Pick<
  Props,
  'showReportModal' | 'deleteDeviation' | 'showGenericNotification'
>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { deviation }
) => {
  return {
    showReportModal: () => dispatch(showReportModalAction(deviation)),
    deleteDeviation: () => dispatch(deleteDeviationAction({ deviation })),
    showGenericNotification: (params: any) =>
      dispatch(addNotification(NotificationType.Generic, params)),
  };
};

export default connect(null, mapDispatchToProps);
